import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import { http } from './backend';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    nameClient: '',
    identificationClient: '',
    idClient: '',
    client: [],
    documents: [],
    isLoading: false,
    page: 1,
    docFiltred: {},
    linkDocsDownload: '',
    totalByModel: {},
    totalByStatus: {},
    totalDetails: {},
    params: {},
    updated_at: null,
    isCached: false,
    dataDoc: {},
    maxResults: 15,
    maxSpedResults: 12,
    speds: {},
    spedFiltered: {},
    itensPerPage: null,
  },
  plugins: [createPersistedState()],
  mutations: {
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_CLIENT_NAME(state, nameClient) {
      state.nameClient = nameClient;
    },
    SET_CLIENT_IDENTIFICATION(state, identificationClient) {
      state.identificationClient = identificationClient;
    },
    SET_CLIENT_ID(state, idClient) {
      state.idClient = idClient;
    },
    SET_CLIENT(state, client) {
      state.client = client;
    },
    SET_DOCUMENTS(state, documents) {
      state.documents = documents;
    },
    SET_DOCUMENTS_COUNT(state, count) {
      state.itensPerPage = count;
    },
    SET_PAGE(state, page) {
      state.page = page;
    },
    SET_DOC_FILTRED(state, docFiltred) {
      state.docFiltred = docFiltred;
    },
    SET_LINK_DOWNLOAD(state, linkDocsDownload) {
      state.linkDocsDownload = linkDocsDownload;
    },
    SET_DOCS_BY_MODEL(state, totalByModel) {
      state.totalByModel = totalByModel;
    },
    SET_DOCS_BY_STATUS(state, totalByStatus) {
      state.totalByStatus = totalByStatus;
    },
    SET_DOCS_BY_DETAILS(state, totalDetails) {
      state.totalDetails = totalDetails;
    },
    SET_DOCS_PARAMS(state, params) {
      state.params = params;
    },
    SET_DOCS_UPDATED_AT(state, updated_at) {
      state.updated_at = updated_at;
    },
    SET_IS_CACHED(state, isCached) {
      state.isCached = isCached;
    },
    SET_DOCS(state, dataDoc) {
      state.dataDoc = dataDoc;
    },
    SET_MAX_RESULTS(state, maxResults) {
      state.maxResults = maxResults;
    },
    SET_MAX_SPED_RESULTS(state, maxSpedResults) {
      state.maxSpedResults = maxSpedResults;
    },
    SET_SPED(state, speds) {
      state.speds = speds;
    },
    SET_SPED_FILTERED(state, spedFiltered) {
      state.spedFiltered = spedFiltered;
    },
  },
  actions: {

    async fetchClient(context) {
      context.commit('SET_LOADING_STATUS', true);
      await http.post('application.get-client').then(response => {
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_CLIENT', response.data)
      })
    },

    async getDocuments(context) {
      const data = {
        page: store.getters.getPage,
        maxResults: store.getters.getMaxResults,
        identification: store.getters.identificationClient,
      }
      context.commit('SET_LOADING_STATUS', true)
      await http.post('clipp.get-xml-by-emissor', data).then(response => {
        context.commit('SET_DOCUMENTS', response.data)
        context.commit('SET_LOADING_STATUS', false)
      })
    },

    async getDocumentsFilter(context) {
      context.commit('SET_LOADING_STATUS', true)
      await http.post('clipp.get-xml-by-emissor', store.getters.getDocFiltred).then(response => {
        context.commit('SET_DOCUMENTS', response.data)
        context.commit('SET_DOCUMENTS_COUNT', response.data.count)
        context.commit('SET_LOADING_STATUS', false)
      })
    },

    cleanLinkDownload(context) {
      context.commit('SET_LINK_DOWNLOAD', '')
    },

    async getTotalsDashboard(context, payload) {
      await http.post('clipp.get-totals',
        {
          ...store.getters.getDataDoc,
          ...payload
        }).then(response => {
        context.commit('SET_LOADING_STATUS', false);
        context.commit('SET_DOCS_BY_MODEL', response.data.totalByModel);
        context.commit('SET_DOCS_BY_STATUS', response.data.totalByStatus);
        context.commit('SET_DOCS_BY_DETAILS', response.data.totalDetails);
        context.commit('SET_DOCS_PARAMS', response.data.params);
        context.commit('SET_DOCS_UPDATED_AT', response.data.updated_at);
        context.commit('SET_IS_CACHED', response.data.isCached);
      });
    },

    async updateTotalsDashboard(context, payload) {
      await http.post('clipp.update-totals',
        {
          ...store.getters.getDataDoc,
          ...payload
        }).then(response => {
        context.commit('SET_LOADING_STATUS', false);
        context.commit('SET_DOCS_BY_MODEL', response.data.totalByModel);
        context.commit('SET_DOCS_BY_STATUS', response.data.totalByStatus);
        context.commit('SET_DOCS_BY_DETAILS', response.data.totalDetails);
        context.commit('SET_DOCS_PARAMS', response.data.params);
        context.commit('SET_DOCS_UPDATED_AT', response.data.updated_at);
        context.commit('SET_IS_CACHED', response.data.isCached);
      });
    },

    async fetchSped(context) {
      const data = {
        identification: store.getters.identificationClient,
        page: store.getters.getPage,
        maxResults: store.getters.getMaxSpedResults,
      }
      context.commit('SET_LOADING_STATUS', true)
      await http.post('clipp.get-sped-by-identification', data).then(response => {
        context.commit('SET_SPED', response.data)
        context.commit('SET_LOADING_STATUS', false)
      })
    },

    async getSpedsFilter(context) {
      context.commit('SET_LOADING_STATUS', true)
      await http.post('clipp.get-sped-by-identification', store.getters.getSpedFiltered).then(response => {
        context.commit('SET_LOADING_STATUS', false)
        context.commit('SET_SPED', response.data)
      })
    },
  },
  getters: {
    nameClient: state => state.nameClient,
    identificationClient: state => state.identificationClient,
    idClient: state => state.idClient,
    client: state => state.client,
    isLoading: state => state.isLoading,
    getDoc: state => state.documents,
    getTotalDoc: state => state.documents.total,
    getPerPage: state => state.itensPerPage,
    getIdsDocs: state => state.documents.ids,
    getPage: state => state.page,
    getDocFiltred: state => state.docFiltred,
    getLinkDocsDownloads: state => state.linkDocsDownload,
    getDocTotalByModel: state => state.totalByModel,
    getDocTotalByStatus: state => state.totalByStatus,
    getDocTotalByDetails: state => state.totalDetails,
    getDocParams: state => state.params,
    getDocUpdatedAt: state => state.updated_at,
    getIsCached: state => state.isCached,
    getDataDoc: state => state.dataDoc,
    getMaxResults: state => state.maxResults,
    getMaxSpedResults: state => state.maxSpedResults,
    getSped: state => state.speds,
    getSpedFiltered: state => state.spedFiltered,
  }
})
export default store;



// WEBPACK FOOTER //
// ./src/public/api/store.js